<script lang="ts" setup></script>
<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3.5" y="13" width="4" height="6" fill="black" />
    <rect x="9.5" y="5" width="4" height="14" fill="black" />
    <rect x="15.5" y="10" width="4" height="9" fill="black" />
  </svg>
</template>
